<script>
  import App from 'src/pc/App'
  import DefaultLayout from './layouts/DefaultLayout'
  import firstLoadingAction from 'src/_mixins/GotoSiteWhenFirstLoading'
  export default {
    extends: App,
    components: {
      DefaultLayout
    },
    mixins: [firstLoadingAction]
  }
</script>

<style>
  .btn_lineBlue {
    height: 40px;
  }
  .btn_lineBlue i {
    font-size: 14px !important;
  }
  body {
    -ms-overflow-style: none;
  }
  ::-webkit-scrollbar {
    display: none;
  }
  .p-show {
    display: none !important;
  }
  .m-show {
    display: inherit !important;
  }
  .ad:after {
    border: 0.9px solid rgba(0,0,0,0.1);
  }
  img {
    image-rendering: unset;
  }
</style>
